<template>
  <div class="point-course" @click="handleBuyBtnClick">
    <div v-if="pointPriceItem.discount != pointPriceItem.point" class="off">
      {{ discountRate }}%off
    </div>
    <img :src="imagePath" class="point-image" />
    <div class="button-container" :class="{ 'discount-button' : pointPriceItem.discount != pointPriceItem.point }">
      <div class="button-styled">
        <div v-if="pointPriceItem.discount != pointPriceItem.point" class="button-text discount">
          <span class="before">{{ t('¥') }}{{ pointPriceItem.point | comma }}</span>
          <span class="arrow">→</span>
          <span class="after">{{ t('¥') }}{{ pointPriceItem.discount | comma }}</span>
        </div>
        <div v-else class="button-text">
          {{ t('¥') }}{{ pointPriceItem.point | comma }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';

export default {
  name: 'PointCourse',
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },

  props: {
    pointPriceItem: {
      type: Object,
    },
    currentUser: {
      type: Object,
    },
  },

  computed: {
    discountReturn() {
      if (this.currentUser && this.currentUser.rank_discount) {
        const discount = this.pointPriceItem.point * (this.currentUser.rank_discount / 100);
        return this.pointPriceItem.point - discount;
      }
      return this.t('購入する');
    },
    bonusPoint() {
      const bonusPoint = parseInt(this.pointPriceItem.point, 10) - parseInt(this.pointPriceItem.price, 10);
      return separateCharacterNumber(bonusPoint);
    },
    imagePath() {
      return `/img/buypoint/${this.pointPriceItem.point}.webp`;
    },
    discountRate() {
      if (this.currentUser && (this.pointPriceItem.discount !== this.pointPriceItem.point)) {
        const discount = this.pointPriceItem.point - this.pointPriceItem.discount;
        const rate = (discount / this.pointPriceItem.point) * 100;
        return Math.round(rate);
      }
      return 0;
    },
  },

  methods: {
    handleBuyBtnClick() {
      this.$emit('handleBuyBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.point-course {
  text-align: left;
  width: 30%;
  margin: 10px 0;
  cursor: pointer;
  position: relative;

  .point-image {
    width: 100%;
    display: block;
  }

  .button-container {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 200px;
    cursor: pointer;
    text-align: center;
    &.discount-button{
      width: 94%;
      bottom: 4%;
    }
  }

  .off{
    top: 18px;
    left: 18px;
    position: absolute;
    background-color: white;
    color: #ff0000;
    border-radius: 20px;
    border: 1px solid #ff0000;
    box-shadow: 0 0 8px #ff0000;
    padding: 2px 10px;
    font-size: 20px;
    @media screen and (max-width: $tabletWidth){
      top: 12px;
      left: 12px;
      font-size: 16px;
      padding: 2px 8px;
    }
    @media screen and (max-width: 580px){
      top: 7px;
      left: 5px;
      font-size: 12px;
      padding: 2px 7px;
    }
  }

  .button-styled {
    background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
    border-radius: 50px;
    padding: 8px 10px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-text {
    font-size: 15px;
    font-weight: bold;
    color: white;
    text-align: center;
    width: 100%;
    pointer-events: none;
    @media screen and (max-width: 500px) {
      font-size: 12px;
    }
    &.discount{
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0px 8px;
      .before{
        position: relative;
        font-size: 11px;
        text-decoration: line-through;
        color: #e6e6e6;
        &:before{
          position: absolute;
          content: "";
          left: 0;
          top: 50%;
          right: 0;
          border-top: 1px solid;
          border-color: inherit;
        }
      }
      .after{
        font-weight: bold;
      }
      @media screen and (max-width: $mobileWidth) {
        &.discount {
          padding: 0px 5px;
          .before {
            font-size: 7px;
          }
          .arrow {
            font-size: 8px;
            font-weight: bold;
          }
          .after {
            font-size: 9px;
          }
        }
      }
    }
  }
}
</style>
